(ns minorodata.components.home-dashboard.shared
  (:require
   ["lucide-react" :refer [InfoIcon TrendingDownIcon TrendingUpDownIcon TrendingUpIcon]]
   [ui.card :as card]
   [ui.skeleton :as skeleton]
   [ui.tooltip :as tooltip]
   [ui.utils :refer [clsx]]))

(def chart-colors
  ["var(--color-sky-500)"
   "var(--color-lime-500)"
   "var(--color-rose-500)"
   "var(--color-orange-500)"
   "var(--color-indigo-500)"
   "var(--color-amber-500)"
   "var(--color-blue-500)"
   "var(--color-emerald-500)"
   "var(--color-slate-500)"
   "var(--color-red-500)"
   "var(--color-teal-500)"
   "var(--color-violet-500)"
   "var(--color-green-500)"
   "var(--color-fuchsia-500)"
   "var(--color-yellow-500)"
   "var(--color-purple-500)"
   "var(--color-cyan-500)"
   "var(--color-pink-500)"])

(defn stat-card [{:keys [title value prev-value hoverable tooltip trend invert icon loading]}]
  (let [trend (or trend
                  (and prev-value
                       (cond
                         (< value prev-value) :down
                         (> value prev-value) :up
                         (= value prev-value) :neutral)))
        color-trend (cond
                      (and invert (= trend :up)) :down
                      (and invert (= trend :down)) :up
                      :else trend)]
    [card/card {:class "rounded-lg"}
     [card/card-content {:class "flex items-center gap-4 p-6"}
      [:div {:class "flex-1"}
       [card/card-description {:class "flex items-center gap-2"}
        title
        (cond
          tooltip
          [tooltip/tooltip-root
           [tooltip/tooltip-trigger {:aria-label (str "About " title)}
            [:> InfoIcon {:size 16}]]
           [tooltip/tooltip-content tooltip]]

          hoverable
          [:> InfoIcon {:size 16}])]
       [card/card-title {:class "flex items-end justify-between gap-4 text-3xl mt-2"}
        (if loading
          [skeleton/skeleton {:width 128 :height 36}]
          [:<>
           value
           (when prev-value
             [:span {:class (clsx "inline-flex gap-2 text-sm font-normal"
                                  {"text-kleene-text-success" (= color-trend :up)
                                   "text-kleene-text-error"   (= color-trend :down)
                                   "text-kleene-text-secondary" (= color-trend :neutral)})}
              [tooltip/tooltip-root
               [tooltip/tooltip-trigger prev-value]
               [tooltip/tooltip-content "Previous period value"]]
              (cond
                (= trend :up)    [:> TrendingUpIcon]
                (= trend :down)  [:> TrendingDownIcon]
                (= trend :neutral) [:> TrendingUpDownIcon])])])]]
      (when icon
        [:div {:class "p-2 rounded-xl bg-kleene-neutral-05"}
         icon])]]))

(defn mini-stat
  [{:keys [icon title value loading icon-class]}]
  [:div
   {:class "flex h-full min-h-16 flex-col justify-center gap-1 p-3"}

   [:div {:class "text-xs text-kleene-text-secondary"}
    title]

   (if loading
     [skeleton/skeleton {:width 56 :height 28}]

     [:div {:class "flex items-center gap-2"}
      (when icon
        [:div
         {:class
          (clsx
           (str
            "flex h-6 w-6 shrink-0 items-center justify-center rounded-md "
            "[&>svg]:h-4 [&>svg]:w-4")
           icon-class)}
         icon])

      [:span
       {:class "text-2xl font-semibold leading-none text-kleene-text-primary"}
       (or value 0)]])])

(def duration-formatter (js/Intl.DurationFormat. "en-GB" #js {:style "narrow"}))

(defn format-duration [seconds]
  (.format duration-formatter #js {:hours   (js/Math.floor (/ seconds 3600))
                                   :minutes (js/Math.floor (mod (/ seconds 60) 60))
                                   :seconds (js/Math.floor (mod seconds 60))}))

(def percentage-formatter (js/Intl.NumberFormat "en-GB" #js {:style "percent" :maximumFractionDigits 2}))
